/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Kind_GeneralInputs */

const cs_pipelines_kind_general = /** @type {(inputs: Pipelines_Kind_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obecné`)
};

const en_pipelines_kind_general = /** @type {(inputs: Pipelines_Kind_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

/**
* | output |
* | --- |
* | "General" |
*
* @param {Pipelines_Kind_GeneralInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_kind_general = /** @type {((inputs?: Pipelines_Kind_GeneralInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Kind_GeneralInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_kind_general(inputs)
	return cs_pipelines_kind_general(inputs)
});